import React from 'react';
import { SpreadsheetGridCell } from '../../../../styles';

interface Props {
  id?: string;
  y: number;
  children: any;
  className?: string;
  onClick?: any;
  onDoubleClick?: any;
  width?: number;
}

const SpreadsheetCell = (props: Props) => {
  const { y, className, onClick, onDoubleClick, children, width, id } = props;

  return (
    <SpreadsheetGridCell
      key={y}
      id={id}
      className={className}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
      style={{
        width: width + 'px',
      }}
    >
      {children}
    </SpreadsheetGridCell>
  );
};

export default SpreadsheetCell;
